import { devFreeze } from "@rpldy/shared";
var defaults = devFreeze({
  allowRegisterNonExistent: true,
  canAddEvents: true,
  canRemoveEvents: true,
  collectStats: false
});
export default defaults;